// @flow

import { TYPOGRAPHY, COLORS } from 'Components/foundation';


export default {
  wrapper: {
    display: 'flex',
    flex: 1,
    height: 31,
    backgroundColor: 'transparent',
    alignItems: 'center',
    padding: '0px 8px',
  },
  text: {
    ...TYPOGRAPHY.BODY4,
    fontWeight: 400,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
  },
  icon: {
    marginLeft: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
